import React from 'react'

interface PageContentProps {
  children: React.ReactNode
  className?: string
  /** Override max width (e.g., 'max-w-5xl', 'max-w-xl'). Defaults to 'max-w-7xl' */
  maxWidth?: string
}

/**
 * PageContent component provides consistent layout for all pages:
 * - Safe area: Top padding for fixed navbar (pt-16 = 64px)
 * - Visual spacing: Additional top padding (pt-6) and bottom padding (pb-8)
 * - Horizontal padding (px-4 on mobile, px-6 on desktop)
 * - Max width constraint with centering (max-w-7xl by default)
 */
export const PageContent: React.FC<PageContentProps> = ({ 
  children, 
  className = '',
  maxWidth = 'max-w-7xl'
}) => {
  return (
    <div className={`pt-16 ${maxWidth} mx-auto`}>
      <div className={`pt-6 pb-8 px-4 md:px-6 ${className}`}>
        {children}
      </div>
    </div>
  )
}

export default PageContent
